<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="班级名称:" label-width="100px">
					<el-input v-model="filters.className" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="所属机构:" label-width="100px">
					<el-select v-model="filters.schoolId" placeholder="请选择" size="small" class="formItem" clearable
						@change="loadClass">
						<el-option v-for="item in schoolDict" :key="item.id" :label="item.schoolName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
					<el-button type="primary" @click="addInfo" size="small">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="grid_data" height="calc(100vh - 220px)" border highlight-current-row v-loading="listLoading"
			@selection-change="(v) => { sels = v }" style="width: 100%;">
			<el-table-column prop="classCode" label="班级编号" width="100"></el-table-column>
			<el-table-column prop="className" label="班级名称" width="180"></el-table-column>
			<el-table-column prop="personNum" label="人数" width="85"></el-table-column>
			<!-- <el-table-column prop="teacherName" label="班级老师" width="100"></el-table-column> -->
			<el-table-column prop="linkTel" label="联系电话" width="150"></el-table-column>
			<el-table-column prop="schoolName" label="所属机构" width="150" show-overflow-tooltip></el-table-column>
			<el-table-column prop="gradeName" label="所属年级" width="150"></el-table-column>
			<el-table-column prop="addTime" label="添加时间" width="140" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column label="操作" min-width="160">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack"
			@getVisible="(v) => { dialogAddShow = v }"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from './classinfoadd.vue'
export default {
	components: { addsave, pagination },
	data() {
		return {
			filters: {
				classCode: '',
				className: '',
				personNum: 0,
				teacherName: '',
				linkTel: '',
				gradeId: '',
				schoolId: '',
				addTime: '',
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			schoolDict: [],
		}
	},
	methods: {
		async loadSchool() {
			let formData = this.$util.jsonToForm({
				schoolName: '',
				logName: '',
				linkTel: '',
				teamPerson: '',
				status: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/school/getschoolinfolist", formData).then(res => {
				this.schoolDict = res.data.data;
			});
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/school/getclassinfolist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/school/classinfodel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		addInfo: function () {
			this.showTitle = "新增班级";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑班级";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
	},
	async created() {
		await this.loadSchool()
		this.getGridData();
	}
}

</script>

<style scoped></style>
